<template>
  <div class="tickets-list fixed-draggable-dynamic-table-wrapper-height">
    <draggable-dynamic-table ref="supportTicketsList"
                             :data="data"
                             :columns="columnsLabel"
                             :options="options"
                             :default-sort-status="sortTableStatus"
                             @filter:remove="setFilter($event, true)"
                             @filter:set="setFilter($event)"
                             @sort:set="setSort($event)"
                             @row:clicked="handleRowClicked($event)"
                             @load:more="getTickets()"/>

    <!--  insert ticket prompt  -->
    <custom-modal :active="insertTicketPromptStatus"
                  :fixed-height="false"
                  :check-change="true"
                  ref="insertPrompt"
                  @close="insertTicketPromptStatus = false">
      <template #header>
        <div class="prompt-header p-3 w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
          <vs-row>
            <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
              <div @click="$u.click('insertTicketBTN')">
                <custom-icon color="success"
                             icon="save-icon"/>
              </div>
            </vs-col>

            <vs-spacer/>

            <vs-col class="prompt-title w-1/2 text-center useral-font-weight-bold text-md">
              {{ $t('tickets.insert.title') }}
            </vs-col>

            <vs-spacer/>

            <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
              <div @click="$u.modal.close($refs.insertPrompt)">
                <custom-icon color="danger"
                             icon="circle-x-icon"/>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </template>
      <template #content>
        <div class="prompt-content py-2 px-3">
          <template>
            <keep-alive>
              <insert-support-ticket @insert="handleReloadTicketsList" />
            </keep-alive>
          </template>
        </div>
      </template>
    </custom-modal>

    <button v-show="false"
            id="insertTicket"
            @click="insertTicketPromptStatus = true"></button>
  </div>
</template>

<script>
import CustomIcon from '@/components/icon/customIcon'
import insertSupportTicket from '../insert/InsertTicket.vue'
import {getTickets} from '@/http/requests/tickets'
import historyStates from '@/mixins/historyStates'
import axios from 'axios'
import CustomModal from '@/components/modal/customModal.vue'
import {getUserTickets} from '@/http/requests/users'
import {getProfileTickets} from '@/http/requests/profile'

export default {
  name: 'TicketList',
  components: {CustomModal, insertSupportTicket, CustomIcon},
  metaInfo () {
    return {
      title: this.$t('tickets.list.title')
    }
  },
  mixins: [historyStates],
  data () {
    return {
      insertTicketPromptStatus: false,
      loadingTimer: 0,
      options: {
        // id: 'supportTicketsList',
        rowKeyField: 'id'
      },
      columnsLabel: [
        {
          field: 'status',
          i18n: 'tickets.general.table.header.status',
          width: '170px',
          minWidth: 170,
          filter: true,
          filterType: 'checkbox',
          filterTypes: [
            {
              id: 0,
              label: this.$t('tickets.general.statusTypes.created'),
              value: 0,
              show: false
            },
            {
              id: 1,
              label: this.$t('tickets.general.statusTypes.portalResponse'),
              value: 1,
              show: false
            },
            {
              id: 2,
              label: this.$t('tickets.general.statusTypes.appResponse'),
              value: 2,
              show: false
            },
            {
              id: 3,
              label: this.$t('tickets.general.statusTypes.pending'),
              value: 3,
              show: false
            },
            {
              id: 4,
              label: this.$t('tickets.general.statusTypes.completed'),
              value: 4,
              show: false
            }
          ],
          align: 'center',
          sortable: true
        },
        {
          field: 'lastUpdate',
          i18n: 'tickets.general.table.header.lastUpdate',
          width: '150px',
          minWidth: 150,
          filter: true,
          filterType: 'date',
          align: 'center',
          sortable: true
        },
        {
          field: 'subject',
          i18n: 'tickets.general.table.header.subject',
          width: '170px',
          minWidth: 170,
          filter: true,
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              i18n: 'components.draggableDynamicTable.filter.types.search',
              id: 1
            }
          ],
          align: 'left',
          ellipsis: true,
          sortable: true
        },
        {
          field: 'responder',
          i18n: 'tickets.general.table.header.responder',
          width: '170px',
          minWidth: 170,
          filter: true,
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              i18n: 'components.draggableDynamicTable.filter.types.search',
              id: 1
            }
          ],
          align: 'left',
          sortable: true
        },
        {
          field: 'creator',
          i18n: 'tickets.general.table.header.creator',
          width: '170px',
          minWidth: 170,
          filter: true,
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              i18n: 'components.draggableDynamicTable.filter.types.search',
              id: 1
            }
          ],
          align: 'left',
          sortable: true
        },
        {
          field: 'rowNumber',
          i18n: 'tickets.general.table.header.row',
          width: '60px',
          minWidth: 60,
          maxWidth: 70,
          align: 'center',
          // sortable: true,
          fixed: true,
          locked: true,
          footer: {}
        }
      ],
      statusTypes: {
        0: this.$t('tickets.general.statusTypes.created'),
        1: this.$t('tickets.general.statusTypes.portalResponse'),
        2: this.$t('tickets.general.statusTypes.appResponse'),
        3: this.$t('tickets.general.statusTypes.pending'),
        4: this.$t('tickets.general.statusTypes.completed')
      },
      data: [],
      selectedPaymentGateway: {},
      selectedFilters: [],
      filters: {},
      sorts: ['order[0]=answered_at,desc'],
      page: 1,
      endedList: false,
      actions: {
        toolbar: [
          {
            id: 'insertTicket',
            icon: 'plus-icon',
            iconPack: 'useral',
            color: 'success',
            permission: 'ticket.create'
          }
        ],
        leftToolbar: [
          /*{
            id: 'printTable',
            icon: 'print-icon',
            iconPack: 'useral'
          },
          {
            id: 'downloadTable',
            icon: 'download-icon',
            iconPack: 'useral'
          },*/
          {
            id: 'settingTable',
            icon: 'sliders-icon',
            iconPack: 'useral'
          }
        ]
      }
    }
  },
  created () {
    if ((['userTicketsList'].includes(this.$route.name) && parseInt(this.$route.params.id) !== parseInt(this.$store.state.auth.user.id))) {
      this.actions.toolbar = []
    }
    this.$nextTick(() => {
      this.$store.dispatch('updateNavbarActions', this.actions)
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
    })

    if (history.state.hasOwnProperty('data') && this.$store.state.helper.prevRoute.name !== null) {
      this.getTableInfoFromHistory()
    } else {
      this.getTickets()
    }
  },
  methods: {
    getTickets () {
      if (!this.endedList) {
        if (this.$refs.supportTicketsList && this.data.length === 0) this.$refs.supportTicketsList.loadMoreStatus = 'FirstLoad'
        else if (this.$refs.supportTicketsList && this.data.length > 0) this.$refs.supportTicketsList.loadMoreStatus = 'Loading'

        let ticketFunc = null
        if (this.$route.name === 'profileTicketsList') {
          ticketFunc = getProfileTickets(this.page, this.filters, this.sorts)
        } else if (this.$route.name === 'userTicketsList') {
          ticketFunc = getUserTickets(this.$route.params.id, this.page, this.filters, this.sorts)
        } else {
          ticketFunc = getTickets(this.page, this.filters, this.sorts)
        }
        ticketFunc.then(response => {
          const tickets = response.data.data

          tickets.forEach((ticket) => {
            this.data.push({
              route: {
                name: 'ticketDetail',
                params: {id: ticket.id}
              },
              id: ticket.id,
              rowNumber: this.data.length + 1,
              subject: ticket.subject || '',
              creator: ticket.initiator ? `${ticket.initiator.name || ''} ${ticket.initiator.family || ''}` : this.$t('tickets.general.labels.unknown'),
              responder: ticket.responder ? `${ticket.responder.name || ''} ${ticket.responder.family || ''}` : this.$t('tickets.general.labels.unknown'),
              lastUpdate: {
                value: this.$u.convertUtcToLocale(ticket.answered_at, this.$u.locale.validator('moment.dateTime')) || '',
                styles: 'direction: ltr;'
              },
              seen: ticket.seen ? this.$t('tickets.general.seenStatusTypes.seen') : this.$t('tickets.general.seenStatusTypes.notSeen'),
              status: this.statusTypes[ticket.status],
              sendStatus: ticket.sent ? this.$t('tickets.general.sendStatusTypes.send') : this.$t('tickets.general.sendStatusTypes.notSend'),
              styles: ticket.seen ? 'backgroundColor: #f0f0f0;' : ''
            })
          })

          this.endedList = response.data.pagination.total_pages === response.data.pagination.current_page
          this.page = response.data.pagination.current_page + 1
          if (response.data.pagination.current_page === 1) {
            const row_index = this.columnsLabel.map((e) => {
              return e.field
            }).indexOf('rowNumber')
            this.columnsLabel[row_index].footer.value = response.data.pagination.total
          }

          if (this.$refs.supportTicketsList) this.$refs.supportTicketsList.loadMoreStatus = ''
        }).catch((error) => {

          if (this.$refs.supportTicketsList && !axios.isCancel(error)) this.$refs.supportTicketsList.loadMoreStatus = 'Danger'
        })
      }
    },
    setFilter (filters) {
      this.selectedFilters = filters
      const filters_list = {}
      Object.keys(filters).forEach((key) => {
        switch (key) {

        case 'creator':
          if (filters[key].search !== '') filters_list.creator = `${filters[key].search}`
          break

        case 'user':
          if (filters[key].search !== '') filters_list.user = `${filters[key].search}`
          break

        case 'subject':
          if (filters[key].search !== '') filters_list.subject = `${filters[key].search}`
          break

        case 'service':
          if (filters[key].search !== '') filters_list.service = `${filters[key].search}`
          break

        case 'operatorName':
          if (filters[key].search !== '') filters_list.operator = `${filters[key].search}`
          break

        case 'lastUpdate':
          if (filters[key].search !== '') {
            let filter = ''
            if (Array.isArray(filters[key].search)) {
              filter = filters[key].search.map(elm => this.$u.convertLocaleToUtc(elm, this.$u.locale.validator('moment.date'))).join(this.$u.globalData.filterSeperator)
            } else {
              filter = this.$u.convertLocaleToUtc(filters[key].search, this.$u.locale.validator('moment.date'))
            }
            filters_list.answered_at = `${filter}`
          }
          break

        case 'sendStatus':
          if (filters[key].search.value > -1) filters_list.sent = `${filters[key].search.value}`
          break

        case 'status':
          if (filters[key].search.length) {
            const status_id = filters[key].search.map(elm => {
              return elm.show ? elm.id : null
            }).filter(elm => {
              return elm !== null
            }).join(this.$u.globalData.filterSeperator)

            if (status_id !== '') filters_list.status = `${status_id}`
          }
          break
        }
      })

      this.data = []
      this.page = 1
      this.endedList = false
      this.filters = filters_list
      this.$nextTick(() => {
        this.getTickets()
      })
    },
    setSort (sorts) {
      this.sortTableStatus = sorts
      const sorts_list = []
      Object.keys(sorts).forEach((key) => {
        switch (key) {

        case 'rowNumber':
          sorts_list.push(`order[0]=id,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'creator':
          sorts_list.push(`order[0]=creator,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'user':
          sorts_list.push(`order[0]=user,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'subject':
          sorts_list.push(`order[0]=subject,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'service':
          sorts_list.push(`order[0]=service,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'operatorName':
          sorts_list.push(`order[0]=operator,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'lastUpdate':
          sorts_list.push(`order[0]=answered_at,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'sendStatus':
          sorts_list.push(`order[0]=sent,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'status':
          sorts_list.push(`order[0]=status,${  sorts[key] ? 'desc' : 'asc'}`)
          break
        }
      })

      if (sorts_list.length === 0) {
        this.sorts.push('order[0]=updated_at,desc')
      }

      this.data = []
      this.page = 1
      this.endedList = false
      this.sorts = sorts_list
      this.$nextTick(() => {
        this.getTickets()
      })
    },
    handleReloadTicketsList () {
      this.data = []
      this.page = 1
      this.endedList = false
      this.insertTicketPromptStatus = false

      this.$nextTick(() => {
        this.getTickets()
      })
    },
    handleRowClicked () {
      this.setTableInfoToHistory()
    }
  }
}
</script>

<style scoped>

</style>
